import { EstimateData } from "./types";

const MAIN_EL: HTMLElement | null = document.querySelector('[data-main-el]');

const getIconsUrl = (): string => {
  let url = `${window.location.origin}/assets/svg-icons.svg?t=${Date.now()}`;
  if (MAIN_EL && MAIN_EL.dataset.iconsUrl ) {
    url = MAIN_EL.dataset.iconsUrl;
  }
  return url;
}

export const ICONS_URL = getIconsUrl();

const NUM_FRCTNS = parseInt(MAIN_EL?.dataset.numFractions || '4');
const NUM_FRCTNS_DISPLAYED = 4;
export const UNIT_IN_PIXELS = 50;
export const HOTSPOT_RADIUS = UNIT_IN_PIXELS/NUM_FRCTNS;

export enum Measurement {
  DEFAULT_WIDTH = 14,
  DEFAULT_DEPTH = 12,
  MAX_DEPTH = 24,
  MAX_HEIGHT = 6,
  MAX_WIDTH = 36,
  MIN_DEPTH = 6,
  MIN_HEIGHT = 2,
  MIN_WIDTH = 6,
  NUM_FRACTIONS = NUM_FRCTNS,
  NUM_FRACTIONS_DISPLAYED = NUM_FRCTNS_DISPLAYED,
  UNIT_WHOLE = 1,
  UNIT_PX = UNIT_IN_PIXELS,
  UNIT_FRACTION = 1/NUM_FRCTNS,
  UNIT_FRACTION_DISPLAYED = 1/NUM_FRCTNS_DISPLAYED,
  UNIT_FRACTION_PX = UNIT_IN_PIXELS/NUM_FRCTNS,
  UNIT_FRACTION_DISPLAYED_PX = UNIT_IN_PIXELS/NUM_FRCTNS_DISPLAYED,
  MIN_INSERT_WIDTH = 2.4375,
  MIN_INSERT_DEPTH = 2.4375,
  MIN_INSERT_DIM_PX = UNIT_IN_PIXELS * 2.4375,
  SEP_WIDTH = 0.4375,
  SEP_WIDTH_PX = 0.4375 * UNIT_IN_PIXELS,
}

export const INNER_RECT_OFFSET = Measurement.SEP_WIDTH / 2;
export const INNER_RECT_OFFSET_PX = Measurement.SEP_WIDTH_PX / 2;

export const DefaultInsertDims =  {
  BELT: {
    width: 4.75 + Measurement.SEP_WIDTH,
    height: 4.75 + Measurement.SEP_WIDTH,
  },
  EARRINGS: {
    width: 2 + Measurement.SEP_WIDTH,
    height: 2 + Measurement.SEP_WIDTH,
  },
  CUSTOM: {
    width: 2 + Measurement.SEP_WIDTH,
    height: 2 + Measurement.SEP_WIDTH,
  },
  SQUARE: {
    width: 2 + Measurement.SEP_WIDTH,
    height: 2 + Measurement.SEP_WIDTH,
  },
  SUNGLASSES: {
    width: 6.75 + Measurement.SEP_WIDTH,
    height: 2.75 + Measurement.SEP_WIDTH,
  },
  NECKLACE: {
    width: 10 + Measurement.SEP_WIDTH,
    height: 2 + Measurement.SEP_WIDTH,
  },
  WATCH: {
    width: 3.75 + Measurement.SEP_WIDTH,
    height: 3.75 + Measurement.SEP_WIDTH,
  },
  CUSHION: {
    width: 4.5 + Measurement.SEP_WIDTH,
    height: 3 + Measurement.SEP_WIDTH,
  },
  PILLOW: {
    width: 3 + Measurement.SEP_WIDTH,
    height: 3 + Measurement.SEP_WIDTH,
  }
}

export const DEFAULT_ESTIMATE_DATA: EstimateData = {
  tray: {
    id: '0',
    title: 'Base Price',
    price: 0,
  },
  otherCharges: []
};